import { dashedEnvPath, getEnvName } from './utils';

const envName = getEnvName(); // 环境变量

// api接口相关
export const UC_API_DOMAIN = `https://pages${dashedEnvPath(envName)}.mohezi.cn/uc/r`;
export const TINMAN_BASE_C_URL = `https://pages${dashedEnvPath(envName)}.mohezi.cn`;
export const TINMAN_BASE_URL = `https://pages${dashedEnvPath(envName)}.mohezi.cn`;

export const MALL_ORDER_LIST = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/mall/center/order/list`;
// 订单详情页
export const MALL_ORDER_DETAIL = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/mall/center/order/detail?orderId=`;

export const MALL_ADDRESS_LIST = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/mall/center/address/list`;

// 抽奖的填地址
export const ACT_ADDRESS = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/mall/market/actAddress/address?rid=`;
// 邀请明细的填地址
export const Price_ADDRESS = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/mall/market/team/address`;

// 包名
export const PACKAGE_NAME = 'mp.mohezi.JoJoUp';

// 授权失效之后进入链接地址
export const AUTH_SIGN_URL = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/uc/r/page/wechatMp/portal/entrance`;
export const AUTH_REDIRECT_PARAMS = 'au_prms';

// 非静默登陆登陆也
export const AUTH_INPUT_LOGIN = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/read/account/login`;

export const PLACEHOLDER_MAP =
  'https://jojopublic.jojoread.com/mall/mall-cashback/activity/image/202104/e701cbe2324347ad8c2affc34cc0bf71.jpg';

export const SERVICE_URL = `https://pages${dashedEnvPath(
  envName
)}.mohezi.cn/read/account/customer-service/list`;

export const SENSORS_SERVER_URL = 'https://sensors.tinman.cn/sa?project=jojoup';

export const READ_BASE_URL = 'https://pages.mohezi.cn/read';
